import { createStore, createStateHook, createActionsHook } from 'react-sweet-state';
import type { Action } from 'react-sweet-state';

import type { AutoFocusTargetOptions } from './types';

type PublishModalMountStateType = {
	shouldDisplayPublishModal: boolean;
	initialFocusTarget: AutoFocusTargetOptions;
};
type PublishModalMountActionsType = {
	openPublishModal: () => Action<PublishModalMountStateType, void, void>;
	closePublishModal: () => Action<PublishModalMountStateType, void, void>;
	setInitialFocusTarget: (
		newFocusTarget: AutoFocusTargetOptions,
	) => Action<PublishModalMountStateType, void, void>;
};

export const PublishModalMountStore = createStore<
	PublishModalMountStateType,
	PublishModalMountActionsType
>({
	name: 'PublishModalMountStore',
	initialState: {
		shouldDisplayPublishModal: false,
		initialFocusTarget: undefined,
	},
	actions: {
		openPublishModal:
			() =>
			({ setState }) =>
				setState({ shouldDisplayPublishModal: true }),
		closePublishModal:
			() =>
			({ setState }) =>
				setState({ shouldDisplayPublishModal: false }),
		setInitialFocusTarget:
			(newFocusTarget) =>
			({ setState }) =>
				setState({ initialFocusTarget: newFocusTarget }),
	},
});

export const usePublishModalMountStore = createStateHook(PublishModalMountStore);
export const usePublishModalMountActions = createActionsHook(PublishModalMountStore);
